import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/christophkranebitter/renehuemer.com/website/src/app/art/blog-client.tsx");
